import { Component, OnInit, Input } from '@angular/core';
import { ImageSizeEnum, FileTypesEnum } from '@shared/enums';
import { IUser } from '@models';

@Component({
    selector: 'anp-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  @Input() public user: IUser;
  @Input() public edit: boolean;

  public size = ImageSizeEnum;
  public fileType = FileTypesEnum;

  public picUrl: string;

  public ngOnInit(): void {
    this.picUrl = ''; //this.user.profilePic;
  }

  public inputListener(image): void {
    if (!!image) this.picUrl = image;
  }

  public getFallbackImage(event): void {
    event.target.src = 'assets/avatar.jpg';
  }
}
